var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:_vm._class},[_c('p',{staticClass:"alert__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"alert__subtitle"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('button',{staticClass:"alert__close",attrs:{"type":"button"},on:{"click":function($event){_vm.$root.alert.type = null}}},[_c('icon-x')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }